import React from 'react'

function DeactivePatient() {
  return (
    <div>DeactivePatient</div>
  )
}

export default DeactivePatient